module.exports = __webpack_public_path__ + "media/images/dummy_item-d4c81aa2a0eddee77f8be3bf7fb7ac22.jpg";